import { render, staticRenderFns } from "./jiang-switch.vue?vue&type=template&id=84862034&scoped=true&"
import script from "./jiang-switch.vue?vue&type=script&lang=js&"
export * from "./jiang-switch.vue?vue&type=script&lang=js&"
import style0 from "./jiang-switch.vue?vue&type=style&index=0&id=84862034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84862034",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/seven/Downloads/Vue/vue-plugin-mine/node_modules/_vue-hot-reload-api@2.3.3@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('84862034', component.options)
    } else {
      api.reload('84862034', component.options)
    }
    module.hot.accept("./jiang-switch.vue?vue&type=template&id=84862034&scoped=true&", function () {
      api.rerender('84862034', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/jiang-switch/jiang-switch.vue"
export default component.exports